import { useMutation } from '@tanstack/react-query';
import { loginApi } from '../api/auth';
import { useAuth } from '../context/AuthContext';
import { useToast } from '../context/ToastContext';

const OTP_KEYWORDS      = ['otp', 'verify', 'verified', 'email not verified', 'not verified'];
const PENDING_KEYWORDS  = ['pending', 'approval', 'approved', 'admin', 'under review'];
const INACTIVE_KEYWORDS = ['inactive', 'deactivated', 'suspended', 'disabled', 'blocked'];

const matchesAny = (msg = '', keywords) =>
  keywords.some((kw) => msg.toLowerCase().includes(kw));

const isUserActive = (userData) => {
  const active =
    userData?.is_active ??
    userData?.active ??
    (userData?.status != null ? userData.status !== 'inactive' : undefined) ??
    true;
  return active;
};

const useLogin = () => {
  const { onLoginSuccess, onLoginOtpRequired, onLoginPendingApproval } = useAuth();
  const { error: toastError } = useToast();

  return useMutation({
    mutationFn: loginApi,
    onSuccess: (data) => {
      const userData = data.host ?? data.user ?? data;

      if (!isUserActive(userData)) {
        toastError('Your account is inactive. Please contact support.');
        return;
      }

      localStorage.setItem('token', data.token);
      localStorage.setItem('user', JSON.stringify(userData));
      onLoginSuccess(userData);
    },
    onError: (err, variables) => {
      const msg = err?.message || '';
      const email = variables?.email || '';

      if (matchesAny(msg, INACTIVE_KEYWORDS)) {
        toastError(msg || 'Your account is inactive. Please contact support.');
        return;
      }

      if (matchesAny(msg, OTP_KEYWORDS)) {
        onLoginOtpRequired(email);
        return;
      }

      if (matchesAny(msg, PENDING_KEYWORDS)) {
        onLoginPendingApproval(email);
        return;
      }

      toastError(msg || 'Login failed. Please try again.');
    },
  });
};

export default useLogin;
